// src/components/pages/LandingPages/b2b/AboutSection.js

import React from "react";
import { Box } from "@mui/material";
import WaterRippleImage from "../../../GlobalFunction/WaterRippleImage";

export default function AboutSection({
  lang = "ZH",
  fonts,
  about,
  prefersReducedMotion = false,

  gifSrc = "/img/LandingPage/b2b/aboutus.gif",
  gifAlt = "overlay gif",
  gifEnabled = true,
  gifZIndex = 3,
}) {
  const fontFamily =
    (fonts && fonts[lang]) ||
    "LINE Seed TW";

  /*
   * Keep the same visible background height as the colored area
   * from AboutOverlaySection, without its additional scroll track.
   */
  const aboutVisualHeight = {
    xs: "60vh",
    sm: "100vh",
    md: "100vh",
  };

  const gifPosBottom = {
    ZH: {
      xs: "35%",
      sm: "35%",
      md: "35%",
    },

    EN: {
      xs: "35%",
      sm: "35%",
      md: "35%",
    },

    JP: {
      xs: "35%",
      sm: "35%",
      md: "35%",
    },
  };

  const gifPosLeft = {
    ZH: {
      xs: "40%",
      sm: "45%",
      md: "50%",
    },

    EN: {
      xs: "40%",
      sm: "48%",
      md: "55%",
    },

    JP: {
      xs: "40%",
      sm: "45%",
      md: "50%",
    },
  };

  return (
    <Box
      component="section"
      sx={{
        position: "relative",

        width: "100%",
        height: aboutVisualHeight,

        overflow: "hidden",
        isolation: "isolate",

        backgroundColor: "#fffffc",
      }}
    >
      {/* =====================================================
          WATER-RIPPLE BACKGROUND
      ====================================================== */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,

          zIndex: 1,

          width: "100%",
          height: "100%",

          overflow: "hidden",
        }}
      >
        <WaterRippleImage
          src="/img/LandingPage/b2b/about-us-bg.webp"
          alt="SEHO 關於水禾"
          prefersReducedMotion={
            prefersReducedMotion
          }
          sx={{
            width: "100%",
            height: "100%",
            minHeight: 0,
          }}
        >
          {/* ===============================================
              GIF OVERLAY
          ================================================ */}
          {gifEnabled && Boolean(gifSrc) && (
            <Box
              component="img"
              src={gifSrc}
              alt={gifAlt}
              draggable={false}
              sx={{
                position: "absolute",

                zIndex: gifZIndex,

                pointerEvents: "none",
                userSelect: "none",

                width: {
                  xs: 1080,
                  md: 780,
                },

                height: "auto",

                bottom:
                  gifPosBottom[lang] ||
                  gifPosBottom.ZH,

                left:
                  gifPosLeft[lang] ||
                  gifPosLeft.ZH,

                maxWidth: {
                  xs: "75%",
                  sm: "75%",
                  md: "75%",
                },
              }}
            />
          )}
        </WaterRippleImage>
      </Box>

      {/* =====================================================
          STATIC ABOUT TEXT
      ====================================================== */}
      <Box
        sx={{
          position: "absolute",

          top: "50%",
          left: 0,

          transform:
            "translateY(-50%)",

          zIndex: 5,

          width: "100%",

          pointerEvents: "none",
        }}
      >
        <Box
          sx={{
            position: "relative",

            left: "45%",

            transform:
              "translateX(-50%)",

            width: "100%",

            maxWidth: {
              xs: "84%",
              sm: "70%",
              md: "52%",
            },

            textAlign: "left",
            color: "#ffffff",
          }}
        >
          {/* Intro line and highlighted phrase */}
          <Box
            sx={{
              fontFamily,
              lineHeight: 2,

              fontSize: {
                xs: 12,
                sm: 15,
                md: 25,
              },

              textAlign: "left",
              display: "block",
            }}
          >
            {about?.prefix}

            <Box
              component="span"
              sx={{
                fontWeight: 700,

                fontSize: {
                  xs: 14,
                  sm: 26,
                  md: 35,
                },

                display: "inline",

                whiteSpace: "nowrap",

                ml: 0.5,
              }}
            >
              {about?.highlight}
            </Box>

            {about?.suffix}
          </Box>

          {/* About body */}
          <Box
            sx={{
              fontFamily,

              fontSize: {
                xs: 12,
                sm: 15,
                md: 25,
              },

              lineHeight: 2,

              letterSpacing: {
                xs: 0.1,
                sm: 0.2,
                md: 0.3,
              },

              mt: {
                xs: 0.5,
                sm: 0.75,
                md: 1,
              },
            }}
          >
            {(about?.body || []).map(
              (line, index) => (
                <React.Fragment key={index}>
                  {line}

                  {index !==
                    (about?.body || [])
                      .length -
                      1 && <br />}
                </React.Fragment>
              ),
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}